export const daneTechniczne = [
    {
        title: 'Dom wolonostojący',
        submenu: [
            {
                Powierzchnia_terenu: '500-580m2',
                Powierzchnia_zabudowy: '99m2',
                Powierzchnia_uzytkowa: '145m2',
                Kubatura: '757m3',
                Zabudowa: 'Dom wolnostojący',
                Ściany_nośne_zewnętrzne_i_wewnętrzne: 'Murowane z betonu komórkowego kl. 15MPa na zaprawie klejowej.',
                Dach: 'Więźba dachowa drewniana dwuspadowa o kontrukcji krokwiowo-jętkowej pokryta blachą w kolorze antracytowym.',
                Instalacja_grzewcza: 'Pompa ciepła z ogrzewaniem podłogowym',
                Instalacja_wentylacyjna: 'System rekuperacji.',
                Ogrodzenie: 'Otwarty front budynku wykonano z pełnego murowanego ogrodzenia, wzdłuż obwodu zastosowano ogrodzenie z paneli siatkowych na podmurówce.',
                Oprogramowanie: 'Możliwość instalacji systemu smarthouse do zdalnego sterowania poszczególnymi urządzeniami, w tym: bramą garażową, pompą ciepła, rekuperacją, oświetleniem, fotowoltaiką, systemami alarmowymi i innymi podobnymi urządzeniami.'
            }
        ],
    },
    {
        title: 'Dom wolnostojący typu blizniak (przewidywany w kolejnych etapach realizacji)',
        submenu: [
            {
                Powierzchnia_terenu: '530-550m2',
                Powierzchnia_zabudowy: '80m2',
                Powierzchnia_uzytkowa: '120m2',
                Kubatura: '680m3',
                Zabudowa: 'Dom wolnostojący',
                Ściany_nośne_zewnętrzne_i_wewnętrzne: 'Murowane z betonu komórkowego kl. 15MPa na zaprawie klejowej.',
                Dach: 'Więźba dachowa drewniana dwuspadowa o kontrukcji krokwiowo-jętkowej pokryta blachą w kolorze antracytowym.',
                Instalacja_grzewcza: 'Pompa ciepła z ogrzewaniem podłogowym',
                Instalacja_wentylacyjna: 'System rekuperacji.',
                Ogrodzenie: 'Otwarty front budynku wykonano z pełnego murowanego ogrodzenia, wzdłuż obwodu zastosowano ogrodzenie z paneli siatkowych na podmurówce.',
                Oprogramowanie: 'Możliwość instalacji systemu smarthouse do zdalnego sterowania poszczególnymi urządzeniami, w tym: bramą garażową, pompą ciepła, rekuperacją, oświetleniem, fotowoltaiką, systemami alarmowymi i innymi podobnymi urządzeniami.'
            }
        ],
    },
];